import colors from 'src/style-utils/colors';
import media from 'src/style-utils/media-queries';
import { Flex } from 'src/style/flexbox.style';
import styled from 'styled-components';

export const FilteredContainer = styled(Flex)`
  gap: 1.2rem;
  overflow-x: auto;
  flex-wrap: no-wrap;
  cursor: grab;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  ::-webkit-scrollbar {
    display: none;
    border: 4px solid red;
  }
  position: static;
  ${media.mobileSm`flex-wrap: wrap;`}
`;

export const FilteredButtonContainer = styled.div`
  border: 0.1rem solid ${colors.textColorBlack};
  padding: 0.8rem 1.2rem;
  display: flex;
  gap: 0.8rem;
  border-radius: 3rem;
  cursor: pointer;
  align-items: center;
  min-width: max-content;
  margin-bottom: 0.1rem;
  background-color: ${colors.textColorBlack};
  color: white;
  [data-disabled='true'] {
    pointer-events: none;
  }
`;
